module.exports = __webpack_public_path__ + "static/media/Frame 84.a1bdb2b0.png";